import { Directive, Input, inject } from '@angular/core'
import { ElderMultiSelectChipsComponent, Sort } from '@elderbyte/ngx-starter'
import { VendorFilter, VendorService } from './vendor.service'

@Directive({
  selector: '[appMultiVendorSelect]',
})
export class VendorMultiSelectDirective {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/
  private select = inject(ElderMultiSelectChipsComponent)
  private vendorService = inject(VendorService)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    this.select.displayProperty = 'name'
    this.select.placeholder = 'manufacturer.title'
    this.select.dataSource = this.vendorService
    this.select.sorts = [new Sort('name', 'asc')]
  }

  /***************************************************************************
   *                                                                         *
   * Properties                                                              *
   *                                                                         *
   **************************************************************************/

  @Input()
  public set selectableIds(ids: string[]) {
    if (ids) {
      this.select.filters = [VendorFilter.ids(ids)]
    }
  }
}
